/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';

const initialState = {
    currentRun: null,
    list: [],
    shared: null,
    inFlight: false,
    error: null
};

function inFlightStatus(run) {
    return !!run && run.status !== 'done' && run.status !== 'error';
}

// Compare just the fields the panel actually renders. Poll responses at 1Hz
// otherwise re-create the run object every tick and force unconditional
// downstream re-renders even when nothing visible changed.
function sameRunSignal(prev, next) {
    if (!prev || !next) return false;
    if (prev.runId !== next.runId) return false;
    if (prev.status !== next.status) return false;
    if (prev.verdict !== next.verdict) return false;
    const a = prev.progress || {};
    const b = next.progress || {};
    return a.status === b.status
        && a.phase === b.phase
        && a.overallPct === b.overallPct;
}

export default function medicReducer(state = initialState, action) {
    switch (action.type) {
        case constants.INPUT_MEDIC_START:
        case constants.FEED_MEDIC_START:
            if (action.status === constants.STATE_SUCCESS) {
                const run = action.payload || null;
                return {
                    ...state,
                    currentRun: run,
                    inFlight: inFlightStatus(run),
                    error: null
                };
            }
            return state;

        case constants.INPUT_MEDIC_STATUS:
        case constants.FEED_MEDIC_STATUS:
            if (action.status === constants.STATE_SUCCESS) {
                const run = (action.payload && action.payload.runId) ? action.payload : null;
                if (sameRunSignal(state.currentRun, run)) {
                    return state;
                }
                return {
                    ...state,
                    currentRun: run || state.currentRun,
                    inFlight: inFlightStatus(run),
                    error: null
                };
            }
            return state;

        case constants.INPUT_MEDIC_LIST:
            if (action.status === constants.STATE_SUCCESS) {
                return {...state, list: Array.isArray(action.payload) ? action.payload : []};
            }
            return state;

        case constants.FEED_MEDIC_SHARE:
            if (action.status === constants.STATE_SUCCESS) {
                return {...state, shared: action.payload || null};
            }
            return state;

        case constants.MEDIC_RESET:
            return initialState;

        default:
            return state;
    }
}
